import styled from '@emotion/styled';
import Theme from 'App.theme';

export const NavigationContainer = styled.nav`
  height: 100%;
  width: 15rem;
  box-shadow: 5px 0 20px ${Theme.greys.GREY0};
  display: flex;
  flex-direction: column;
`;

export const LogoContainer = styled.div`
  width: 100%;
  height: 120px;
  text-align: center;

  img {
    max-width: 100%;
    max-height: 100%;
    padding-top: 20px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const NavButtonContainer = styled.div`
  width: 100%;
  padding: 3rem 1rem;
`;

export const NavLinksContainer = styled.nav`
  margin: 1.5rem 0;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

interface NavListItemProps {
  active: boolean;
}

export const NavListItem = styled.ul<NavListItemProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${props => (props.active ? Theme.colours.primaryDark : 'unset')};
  transition: all 0.3s;
  margin: 0;
  padding: 1rem;
  border-left: ${props => (props.active ? `4px solid ${Theme.colours.primaryDark}` : '0px solid #FFF')};

  & :hover {
    background-color: ${Theme.greys.GREY0};
    border-left: 4px solid ${Theme.colours.primaryDark};
  }
`;

export const NavListLogout = styled(NavListItem)`
  margin-top: auto;
`;
